<script>
    import Rectangle from "./Rectangle";

    export default {
        components: { Rectangle },
    }
</script>

<template>
    <div>
        <rectangle color="red" />
        <rectangle color="blue" />
        <rectangle color="green" />
        <rectangle color="orange" />
    </div>
</template>
